import React from 'react';
import { css } from '@emotion/react';
import Colors from '../../../types/colors';
import LoadingSpinner from './loading-spinner.view';

interface FullScreenLoadingProps {
  message?: string;
}

// PDF 생성 등 시간이 걸리는 작업 중 화면 전체를 덮는 로딩 오버레이
const FullScreenLoading = ({ message = 'PDF를 생성하고 있습니다...' }: FullScreenLoadingProps) => {
  const overlay = css`
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    background-color: rgba(0, 0, 0, 0.4);
  `;
  const text = css`
    color: ${Colors['white_regular']};
    font-size: 14px;
    font-weight: 500;
  `;

  return (
    <div css={overlay}>
      <LoadingSpinner />
      {message && <p css={text}>{message}</p>}
    </div>
  );
};

export default FullScreenLoading;
